<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="loco-status-tbl-header">
    <span class="uppercase-bold-12">{{configData && configData.locoStatusLabel.locomotiveStatus}}</span>
    <div class="add-search-row">
        <button class="p-button-primary" tabindex="{{tabIndex + 2}}" id="locoStatusAddNewBtn" title="Add New Row" (click)="addNewLocoStatus();">{{configData && configData.locoStatusLabel.addNew}}</button>
        <input class="p-inputfield train-placeholder" tabindex="{{tabIndex + 4}}" maxlength="14" type="text" placeholder="Search" id="locoStatusFilterText" spellcheck="false" [(ngModel)]="searchText" (focus)='setPageMode($event);' (blur)='resetPageMode();'>
        <i class="fa fa-search" tabindex="{{tabIndex + 6}}" *ngIf="!isSearchClick" id="searchFilterBtnId" (click)="searchLocoStatus()"></i>
        <i class="fa fa-times input-clear-icon" tabindex="{{tabIndex + 6}}" *ngIf="isSearchClick" (click)="clearLocoStatus()"></i>
    </div>
</div>